// src/DriverLogin.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import Login from "./Login";

// ✅ bus1..bus15 allowed
const isValidBusId15 = (x) => /^bus([1-9]|1[0-5])$/i.test(String(x || ""));

export default function DriverLogin() {
  const navigate = useNavigate();

  const onLogin = async () => {
    const u = auth.currentUser;
    if (!u) throw new Error("Login failed. Please try again.");

    const snap = await getDoc(doc(db, "drivers", u.uid));

    if (!snap.exists()) {
      await signOut(auth);
      throw new Error("This account is not registered as DRIVER.");
    }

    const d = snap.data() || {};
    const busId = String(d.busId || "").toLowerCase();

    if (!isValidBusId15(busId)) {
      await signOut(auth);
      throw new Error(
        "Driver busId not set / invalid. Please set drivers/{uid}.busId as bus1..bus15 in Firestore."
      );
    }

    // ✅ store for DriverDashboard
    localStorage.setItem("driverBusId", busId);
    localStorage.setItem("driverEmail", u.email || "");

    navigate("/driver", { replace: true });
  };

  return (
    <Login
      role="driver"
      title="Driver Login"
      subtitle="Email/Password only"
      onLogin={onLogin}
    />
  );
}